import { Link, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Column } from "../components/Column";
import { HomeScreen } from "../../features/home/presentation/pages/HomeScreen";
import { TextComponent } from "../components/TextComponent";
import { useEffect, useRef } from "react";
import { Row } from "../components/Row";
import { Lottery } from "../../features/lottery/presentation/pages/Lottery";
import { CreateLottery } from "../../features/lottery/presentation/pages/CreateLottery";
import { LotterySuccess } from "../../features/lottery/presentation/pages/LotterySuccess";

export const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route
					path="/"
					element={<HomeScreen />}
				/>
				<Route
					path="createlottery"
					element={<CreateLottery />}
				/>
				<Route
					path="lottery/:id"
					element={<Lottery />}
				/>
				<Route
					path="lottery/:id/success"
					element={<LotterySuccess />}
				/>
			</Route>
			<Route
				path="/*"
				element={<Navigate to="/" />}
			/>
		</Routes>
	);
};

const Layout: React.FC = () => {
	const location = useLocation();
	const mainRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainRef.current) mainRef.current.scrollTo({ top: 0, behavior: "smooth" });
	}, [location.pathname]);

	return (
		<Column
			ref={mainRef}
			className="overflow-y-auto relative font-red-hat-display  min-h-svh"
		>
			<Row
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				className="lg:gap-2 py-5 md:py-7 bg-orange-100 w-full px-4"
				responsiveCol
			>
				<Link
					to="/"
					className="flex gap-2 items-center justify-center"
				>
					<img
						src="/currency.svg"
						className="select-none w-8 lg:w-10 aspect-square"
						draggable={false}
						alt="moneda de oro con trebol en el centro"
					/>
					<TextComponent
						variant="h1"
						className="uppercase tracking-widest font-bold text-orange-400 text-center font-lilita-one"
					>
						OLLY <span className="text-orange-600">SUERTE</span>
					</TextComponent>
				</Link>
				<hr className="max-md:hidden w-[1px] bg-orange-600 h-14 mx-4" />
				<TextComponent
					variant="h3"
					className="text-orange-700"
				>
					Sorteo con lista de participantes
				</TextComponent>
			</Row>
			<main className="w-full sm:w-[30rem] md:w-[40rem] xl:w-[40rem] 2xl:w-[50rem] self-center flex-grow">
				<Outlet />
			</main>
			<Row
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				className="py-4 md:py-4 bg-orange-500 w-full px-4 mt-auto"
				responsiveCol
			>
				<TextComponent
					variant="h5"
					className="text-orange-100"
				>
					Creado por{" "}
					<a
						className="underline font-bold"
						href="https://hestranho.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						hestranho
					</a>
				</TextComponent>
			</Row>
		</Column>
	);
};
